import React, { useState } from "react";
import { Link } from "react-router-dom";

const KilDashboardOrderList = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [selectedPeriod, setSelectedPeriod] = useState("Cette semaine");

  const tabs = [
    { id: "all", label: "Tous les statuts" },
    { id: "placed", label: "C. Passées" },
    { id: "processing", label: "En traitement" },
    { id: "delivery", label: "En cours de livraison" },
    { id: "delivered", label: "Livrée" }
  ];

  const kpiCards = [
    {
      title: "Commandes passées",
      value: "1.193.000",
      currency: "FCFA",
      change: "+10%",
      changeValue: "10.150Fcfa Aujourd'hui",
      isPositive: true,
      icon: "🛒"
    },
    {
      title: "En traitement",
      value: "775.000",
      currency: "FCFA",
      change: "+10%",
      changeValue: "10.150Fcfa Aujourd'hui",
      isPositive: true,
      icon: "📦"
    },
    {
      title: "En cours de livraison",
      value: "445.050",
      currency: "FCFA",
      change: "+10%",
      changeValue: "10.150Fcfa Aujourd'hui",
      isPositive: true,
      icon: "🚚"
    },
    {
      title: "Livrée avec succès",
      value: "45",
      currency: "",
      change: "-10%",
      changeValue: "10.150Fcfa Aujourd'hui",
      isPositive: false,
      icon: "✅"
    }
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex justify-between items-start mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Commandes
            <div className="w-16 h-0.5 bg-orange-500 mt-2"></div>
          </h1>
          <div className="text-sm text-gray-600">
            <Link to="/dashboard" className="text-orange-500 hover:text-orange-600">
              Tableau de bord
            </Link>
            <span className="mx-2">{'>'}</span>
            <span>Commandes</span>
          </div>
        </div>
        
        {/* Date Selector */}
        <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50">
          <span className="text-gray-400">📅</span>
          <span className="text-gray-700">{selectedPeriod}</span>
          <span className="text-gray-400">▼</span>
        </button>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {kpiCards.map((card, index) => (
          <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <span className="text-2xl">{card.icon}</span>
                <h3 className="text-lg font-semibold text-gray-900">{card.title}</h3>
              </div>
            </div>
            <div className="mb-2">
              <span className="text-3xl font-bold text-gray-900">{card.value}</span>
              {card.currency && (
                <span className="text-lg font-normal text-gray-600 ml-1">{card.currency}</span>
              )}
            </div>
            <div className={`flex items-center gap-1 text-sm ${
              card.isPositive ? 'text-green-600' : 'text-red-600'
            }`}>
              <span>{card.change}</span>
              <span>{card.isPositive ? '↑' : '↓'}</span>
              <span>{card.changeValue}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Tab Navigation */}
      <div className="flex border-b border-gray-200 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
              activeTab === tab.id
                ? 'text-gray-900 border-orange-500'
                : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Action Bar / Filters */}
      <div className="flex items-center gap-4 mb-6">
        {/* Search Bar */}
        <div className="relative flex-1 max-w-md">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-gray-400">🔍</span>
          </div>
          <input
            type="text"
            placeholder="Recherche..."
            className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
          />
        </div>

        {/* Filter Button */}
        <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50">
          <span className="text-gray-400">⚙️</span>
          <span className="text-gray-700">Filtre</span>
        </button>

        {/* Display Selector */}
        <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50">
          <span className="text-gray-400">👁️</span>
          <span className="text-gray-700">Afficher</span>
          <span className="text-gray-900 font-medium">10</span>
          <span className="text-gray-400">▼</span>
        </button>
      </div>

      {/* Orders Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-4 text-left">
                  <div className="flex items-center">
                    <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                    <span className="ml-3 text-sm font-medium text-gray-900">ID</span>
                  </div>
                </th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">PRODUIT</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">PRIX</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">CLIENT</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">DATE</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">STATUTS</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">ACTION</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {/* Sample order rows */}
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((orderNum) => (
                <tr key={orderNum} className="hover:bg-gray-50">
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                      <span className="ml-3 text-sm text-gray-900">OD24321</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <img src="/images/ecouteur.png" alt="Product" className="w-10 h-10 rounded-lg object-cover mr-3" />
                      <div>
                        <div className="text-sm font-medium text-gray-900">Produit {orderNum}</div>
                        <div className="text-sm text-gray-500">+{Math.floor(Math.random() * 4) + 1} Produits</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div>
                      <div className="text-sm font-medium text-gray-900">{(Math.random() * 100000 + 20000).toFixed(0)} FCFA</div>
                      <div className="text-sm text-gray-500">{['Visa \'9082', 'Bank Transfer', 'COD'][Math.floor(Math.random() * 3)]}</div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      <img src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="User" className="w-8 h-8 rounded-full mr-3" />
                      <div>
                        <div className="text-sm font-medium text-gray-900">Client {orderNum}</div>
                        <div className="text-sm text-gray-500">@client{orderNum}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-sm text-gray-900">14 Jan 2024</div>
                    <div className="text-sm text-gray-500">10:00</div>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`inline-flex px-3 py-1 text-xs font-medium rounded-full ${
                      ['bg-purple-100 text-purple-800', 'bg-orange-100 text-orange-800', 'bg-blue-100 text-blue-800', 'bg-green-100 text-green-800', 'bg-red-100 text-red-800'][Math.floor(Math.random() * 5)]
                    }`}>
                      {['Nouvelle C.', 'En traitement', 'Livraison', 'Livré', 'Annulé'][Math.floor(Math.random() * 5)]}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center space-x-4">
                      <Link to={`/dashboard/orders/OD24321`} className="text-gray-400 hover:text-blue-600">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/><circle cx="12" cy="12" r="3"/></svg>
                      </Link>
                      <button className="text-gray-400 hover:text-green-600">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pencil-icon lucide-pencil"><path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"/><path d="m15 5 4 4"/></svg>
                      </button>
                      <button className="text-gray-400 hover:text-red-600">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash2-icon lucide-trash-2"><path d="M10 11v6"/><path d="M14 11v6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="bg-white px-6 py-4 border-t border-gray-200 flex items-center justify-between">
          <div className="text-sm text-gray-700">
            Affichage 1-10 sur 100
          </div>
          <div className="flex items-center space-x-2">
            <button className="px-3 py-1 text-gray-500 hover:text-gray-700">◀</button>
            <button className="px-3 py-1 text-white bg-orange-500 rounded-lg">1</button>
            <button className="px-3 py-1 text-gray-700 hover:text-orange-500">2</button>
            <button className="px-3 py-1 text-gray-700 hover:text-orange-500">3</button>
            <button className="px-3 py-1 text-gray-700 hover:text-orange-500">4</button>
            <button className="px-3 py-1 text-gray-700 hover:text-orange-500">5</button>
            <span className="px-2 text-gray-500">...</span>
            <button className="px-3 py-1 text-gray-500 hover:text-gray-700">▶</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KilDashboardOrderList;
